import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Select from "react-select";
import Alert from "sweetalert";
import * as yup from "yup";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Header from "../../components/Header";
import MainServices from "../../components/MainServices";
import Title from "../../components/Title";
import api from "../../services/api";

import {
  Aside,
  Container,
  Content,
  ContentBody,
  ContentMain,
  Main,
  ContentBox,
  AvisoBox,
  AvisoTitle,
  AvisoContent,
  Form,
  FieldContainer,
  Label,
  InputText,
  TextArea,
  Collumn,
  CollumnContainer,
  HorarioContainer,
  HorarionButton,
  Enviar,
  EnviarContainer,
} from "./styles";
import { format, formatISO, getDay, parseISO } from "date-fns";

const destino = [
  { value: "Secretaria e Cadastro", label: "Secretaria e Cadastro", sedes: [2, 4] },
  { value: "Financeiro", label: "Financeiro", sedes: [2, 4] },
  // { value: "Jurídico", label: "Jurídico", sedes: [4] },
  { value: "Fiscalização", label: "Fiscalização", sedes: [5, 3, 4, 2] },
];

const defaultHorario = [
  // { horario: "08:00", disabled: false },
  // { horario: "09:00", disabled: false },
  // { horario: "10:00", disabled: false },
  // { horario: "11:00", disabled: false },
  // { horario: "13:00", disabled: false },
  // { horario: "14:00", disabled: false },
  // { horario: "15:00", disabled: false },
  // { horario: "16:00", disabled: false },
];

const formSchema = yup.object().shape({
  name: yup.string().required("O nome precisa ser informado."),
  email: yup.string().email("Deve ser um email valido").required("O email precisa ser informado").typeError("Deve ser um email valido"),
  phone: yup.string().required("O telefone precisa ser informado"),
  horario: yup.string().required("O horario precisa ser selecionado"),
  setor_destino: yup.string().required("O destino precisa ser selecionado."),
  date: yup.date().required("A data precisa ser informada.").typeError("A data deve ser informada"),
  solicitacao: yup.string().required("A solicitação precisa ser informada"),
});

function Agendamento() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [horario, setHorario] = useState("");
  const [setor_destino, setSetorDestino] = useState("");
  const [cro, setCRO] = useState("");
  const [sede, setSede] = useState("");
  const [date, setDate] = useState(null);
  const [solicitacao, setSolicitacao] = useState("");
  const [sedeOptions, setSedeOptions] = useState([]);
  const [horarios, setHorarios] = useState(defaultHorario);
  const [disabled, setDisabled] = useState(false);
  const [configAgendamento, setConfigAgendamento] = useState(null);

  useEffect(() => {
    async function LoadData() {
      try {
        await api.get("/sede").then(({ data }) => {
          let sedes = [];
          data.forEach(item => {
            sedes.push({ value: item.id, label: item.name });
          });
          setSedeOptions(sedes);
        });
      } catch (error) {
        Alert("Erro", `${error.errors}`, "error");
      }
    }
    LoadData();
  }, []);

  const handleBloqueio = async value => {
    try {
      if (new Date(value).getDate()) {
        const selected = formatISO(new Date(value), { representation: "date" });
        const diaSemana = getDay(value);

        // Busca configuração ativa
        if (sede && setor_destino) {
          try {
            const { data: config } = await api.get(`/config_agendamentos/active?sede_id=${sede}&setor=${setor_destino}`);
            setConfigAgendamento(config);

            // Verifica bloqueio de fins de semana (por padrão sempre bloqueado)
            // Só permite se explicitamente desbloqueado na configuração
            const bloquearFinsSemana = config.regras_especiais?.bloquear_fins_semana !== false; // Default: true
            if (bloquearFinsSemana && (diaSemana === 0 || diaSemana === 6)) {
              return false;
            }

            // Verifica datas bloqueadas
            if (config.datas_bloqueadas && config.datas_bloqueadas.includes(selected)) {
              return false;
            }

            // Verifica se a data é no passado
            if (selected <= formatISO(new Date(), { representation: "date" })) {
              return false;
            }

            return true;
          } catch (error) {
            console.log("Erro ao buscar configuração:", error);
            // Fallback: bloqueia fins de semana (sempre) e datas passadas
            // Fins de semana são sempre bloqueados por padrão
            if (diaSemana === 0 || diaSemana === 6) {
              return false;
            }
            if (selected <= formatISO(new Date(), { representation: "date" })) {
              return false;
            }
            return true;
          }
        }

        // Se não tem sede ou setor, bloqueia fins de semana (sempre) e datas passadas
        // Fins de semana são sempre bloqueados por padrão
        if (diaSemana === 0 || diaSemana === 6) {
          return false;
        }

        if (selected <= formatISO(new Date(), { representation: "date" })) {
          return false;
        }

        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  function disableWeekends(date) {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    const dataSelecionada = new Date(date);
    dataSelecionada.setHours(0, 0, 0, 0);

    // Desabilita fins de semana
    if (date.getDay() === 0 || date.getDay() === 6) {
      return true;
    }

    // Desabilita datas passadas
    if (dataSelecionada < hoje) {
      return true;
    }

    return false;
  }

  const handleDate = async value => {
    const diaSemana = getDay(value);

    if (!diaSemana) {
      return false;
    }
    if (sede && setor_destino) {
      const isAvailable = await handleBloqueio(value);
      if (isAvailable) {
        setDate(value);

        try {
          // Busca configuração ativa para obter horários disponíveis
          const { data: config } = await api.get(`/config_agendamentos/active?sede_id=${sede}&setor=${setor_destino}`);

          // Busca agendamentos existentes
          const { data: agendamentosExistentes } = await api.get(
            `/check_data?date=${format(value, "yyyy/MM/dd")}&setor_destino=${setor_destino}&sede_id=${sede}`
          );

          // Usa horários da configuração ou padrão
          const horariosDisponiveis = config.horarios_disponiveis || defaultHorario.map(h => h.horario);
          const limitePorHorario = config.regras_especiais?.limite_por_horario || 1;

          // Verifica se a data selecionada é hoje
          const agora = new Date();
          const hoje = new Date();
          hoje.setHours(0, 0, 0, 0);
          const dataSelecionada = new Date(value);
          dataSelecionada.setHours(0, 0, 0, 0);
          const isHoje = dataSelecionada.getTime() === hoje.getTime();
          const horaAtual = agora.getHours() * 100 + agora.getMinutes(); // Formato HHMM

          let horarios_ = horariosDisponiveis.map(horario => {
            const agendado = agendamentosExistentes.find(a => a.horario === horario);
            const count = agendado ? parseInt(agendado.count) : 0;

            // Se é hoje, desabilita horários que já passaram
            let horarioPassado = false;
            if (isHoje) {
              const [horas, minutos] = horario.split(":").map(Number);
              const horarioNumerico = horas * 100 + minutos;
              if (horarioNumerico <= horaAtual) {
                horarioPassado = true;
              }
            }

            return {
              horario,
              disabled: count >= limitePorHorario || horarioPassado,
            };
          });

          setHorarios(horarios_);
        } catch (error) {
          console.log(error);
          Alert("Erro", "Erro ao buscar horários, tente novamente", "error");
        }
      } else {
        Alert("Erro", "Data indisponível, selecione outra data", "error");
      }
    }
  };

  const handleSubmit = async () => {
    // Validação adicional: verifica se não está agendando para data/horário passado
    const hoje = new Date();
    const dataSelecionada = new Date(date);
    const dataSelecionadaFormatada = formatISO(dataSelecionada, { representation: "date" });
    const hojeFormatado = formatISO(hoje, { representation: "date" });

    // Se a data é hoje, verifica se o horário já passou
    if (dataSelecionadaFormatada === hojeFormatado) {
      const [horas, minutos] = horario.split(":").map(Number);
      const horarioSelecionado = new Date();
      horarioSelecionado.setHours(horas, minutos, 0, 0);

      if (horarioSelecionado <= hoje) {
        Alert("Erro", "Não é possível agendar para um horário que já passou hoje.", "error");
        return;
      }
    }

    // Se a data é no passado
    if (dataSelecionadaFormatada < hojeFormatado) {
      Alert("Erro", "Não é possível agendar para uma data no passado.", "error");
      return;
    }

    const data = { name, email, phone, horario, setor_destino, cro, sede_id: sede, date, solicitacao };

    try {
      await formSchema.validate(data);
    } catch (err) {
      Alert("Erro", `${err.errors}`, "error");
      return;
    }

    setDisabled(true);
    try {
      await api.post("/agendamento", data);
      setName("");
      setEmail("");
      setPhone("");
      setHorario("");
      setSetorDestino("");
      setCRO("");
      setSede("");
      setDate(null);
      setSolicitacao("");
      Alert("Sucesso", "Agendamento realizado com sucesso!", "success");
    } catch (err) {
      const apiError = err.response && err.response.data && err.response.data.error;
      const message = typeof apiError === "string" ? apiError : "Não foi possível realizar o agendamento. Tente novamente.";
      Alert("Erro", message, "error");
    } finally {
      setDisabled(false);
    }
  };

  const horariosRender = horarios.map((item, index) => (
    <HorarionButton
      key={index}
      className={horario === item.horario ? "active" : ""}
      disabled={item.disabled}
      onClick={
        item.disabled
          ? () => {}
          : () => {
              if (date) {
                setHorario(item.horario);
              } else {
                Alert("Erro", "Selecione a data primeiro", "error");
              }
            }
      }>
      {item.horario}
    </HorarionButton>
  ));

  return (
    <div>
      <Helmet>
        <title>Agendamento Online - {process.env.REACT_APP_TITLE}</title>
        <meta name="description" content={process.env.REACT_APP_DESCRIPTION} />
        <meta property="og:title" content={`Agendamento Online - ${process.env.REACT_APP_TITLE}`} />
        <meta name="title" content={`Agendamento Online - ${process.env.REACT_APP_TITLE}`} />
        <meta property="og:description" content={process.env.REACT_APP_DESCRIPTION} />
        <meta property="og:image" content="https://cromt.org.br/logo512.png" />
        <meta property="og:site_name" content="CRO-MT" />
        <meta property="og:url" content={global.window ? global.window.location : ""} />
      </Helmet>
      <Main id="main">
        <Container>
          <Content>
            <Title title="Agendamento Online" />
            <ContentMain>
              <Aside>
                <MainServices />
              </Aside>
              <ContentBody>
                <ContentBox>
                  {/*<AvisoBox>
                    <AvisoTitle>Aviso</AvisoTitle>
                    <AvisoContent>
                      Considerando a Decisão CRO-MT 018/2020, serão mantidos e priorizados os serviços remotos e, o atendimento presencial, ocorrerá somente em
                      casos excepcionais, mediante agendamento prévio e autorizado, enquanto perdurar a pandemia do Covid-19.
                    </AvisoContent>
                  </AvisoBox>*/}
                  <Form>
                    <FieldContainer>
                      <Label>LOCAL</Label>
                      <Select
                        placeholder="Selecione"
                        options={sedeOptions}
                        onChange={({ value }) => {
                          setName("");
                          setEmail("");
                          setPhone("");
                          setHorario("");
                          setSetorDestino("");
                          setCRO("");
                          setDate(null);
                          setSolicitacao("");
                          setSede(value);
                          setConfigAgendamento(null);
                        }}
                      />
                    </FieldContainer>
                    <FieldContainer>
                      <Label>NOME COMPLETO</Label>
                      <InputText value={name} onChange={e => setName(e.target.value)} required={true} />
                    </FieldContainer>
                    <FieldContainer>
                      <Label>EMAIL</Label>
                      <InputText value={email} onChange={e => setEmail(e.target.value)} required={true} />
                    </FieldContainer>
                    <Collumn>
                      <CollumnContainer>
                        <FieldContainer>
                          <Label>TELEFONE</Label>
                          <InputText value={phone} onChange={e => setPhone(e.target.value)} required={true} />
                        </FieldContainer>
                      </CollumnContainer>
                      <CollumnContainer>
                        <FieldContainer>
                          <Label>Nº DO CRO-MT</Label>
                          <InputText value={cro} onChange={e => setCRO(e.target.value)} required={true} />
                        </FieldContainer>
                      </CollumnContainer>
                    </Collumn>
                    <FieldContainer>
                      <Label>SETOR DE DESTINO</Label>
                      <Select
                        placeholder="Selecione"
                        options={destino.filter(i => i.sedes.includes(parseInt(sede)))}
                        onChange={({ value }) => {
                          setSetorDestino(value);
                          setDate(null);
                          setHorario("");
                          setConfigAgendamento(null);
                        }}
                        required={true}
                      />
                    </FieldContainer>
                    <Collumn>
                      <CollumnContainer>
                        <FieldContainer>
                          <Label>DATA</Label>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              shouldDisableDate={disableWeekends}
                              disableToolbar
                              format="dd/MM/yyyy"
                              margin="normal"
                              value={date}
                              onChange={handleDate}
                              minDate={new Date()}
                              required
                            />
                          </MuiPickersUtilsProvider>
                        </FieldContainer>
                      </CollumnContainer>
                      <CollumnContainer>
                        <FieldContainer>
                          <Label>HORÁRIO</Label>
                          <HorarioContainer>{horariosRender}</HorarioContainer>
                        </FieldContainer>
                      </CollumnContainer>
                    </Collumn>
                    <FieldContainer>
                      <Label>SOLICITAÇÃO</Label>
                      <TextArea rows="2" value={solicitacao} onChange={e => setSolicitacao(e.target.value)} required={true} />
                    </FieldContainer>
                    <EnviarContainer>
                      <Enviar disabled={disabled} onClick={handleSubmit}>
                        Enviar
                      </Enviar>
                    </EnviarContainer>
                  </Form>
                </ContentBox>
              </ContentBody>
            </ContentMain>
          </Content>
        </Container>
      </Main>
      <Header />
    </div>
  );
}

export default Agendamento;
